import trackEvent from './trackEvent'

export default trackEvent
